import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function SiteFooter() {
  const cols = [
    ["Find Care", [["Start a care search", "/find-care"], ["Browse providers", "/providers"]]],
    ["Find Work", [["Healthcare jobs", "/jobs"], ["Build your Passport", "/register?role=worker"]]],
    ["Providers", [["List your organization", "/register?role=provider"], ["Sign in", "/login"]]],
  ];
  return (
    <footer className="bg-[#00281F] text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2 space-y-4">
          <Logo light />
          <p className="text-sm text-slate-400 max-w-sm">Find Care. Find Work. Grow Your Care Business. A healthcare marketplace launching in Pennsylvania and built for every state.</p>
        </div>
        {cols.map(([h, links]) => (
          <div key={h}>
            <div className="text-white font-semibold mb-3 font-display">{h}</div>
            <ul className="space-y-2 text-sm">{links.map(([t, to]) => <li key={t}><Link className="hover:text-teal-300 transition-colors" to={to}>{t}</Link></li>)}</ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-400 flex flex-col md:flex-row gap-2 justify-between">
          <span>© 2026 Zunvel™. All rights reserved. Care. Work. Grow. · Development preview — contains clearly labeled DEMO data.</span>
          <span>Zunvel is a marketplace and does not provide medical care. Zunvel does not claim HIPAA compliance.</span>
        </div>
      </div>
    </footer>
  );
}
